module.exports = __webpack_public_path__ + "img/rsb.f9e7c027.svg";